/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import type { EntWebsiteBlockWhyQuery, EntWebsiteWhyFragment } from 'bundles/ent-website/__generated__/contentfulTypes';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import BlockLayout from 'bundles/ent-website/contentful/core/BlockLayout';
import Image from 'bundles/ent-website/contentful/core/Image';
import Markdown from 'bundles/ent-website/contentful/core/Markdown';
import { entWebsiteBlockWhyQuery } from 'bundles/ent-website/queries/EntWebsiteWhy';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';
import withBlockQuery from 'bundles/ent-website/utils/withBlockQuery';

type Props = BlockModuleInnerProps<EntWebsiteWhyFragment>;

export function WhyModule({ content, assembly }: Props) {
  const { visibility } = assembly;
  const { headline, description, image } = content;

  const imagePanel = () =>
    image ? <Image content={image} width="auto" css={{ maxWidth: '100%', maxHeight: 500 }} /> : null;
  const contentPanel = () => (
    <>
      {visibility.headline && headline && (
        <Typography variant="d2semibold" color="inherit">
          {headline}
        </Typography>
      )}
      {visibility.description && description && (
        <Typography2 variant="bodyPrimary" component="div" color="inherit">
          <Markdown source={description} module={content} />
        </Typography2>
      )}
    </>
  );

  return <BlockLayout assembly={assembly} renderContent={contentPanel} renderImage={imagePanel} />;
}

// @ts-expect-error TSMIGRATION-5.0 TS2344
export const BlockWhyModule = withBlockQuery<EntWebsiteWhyFragment, EntWebsiteBlockWhyQuery>(entWebsiteBlockWhyQuery)(
  WhyModule
);
